module.exports = __webpack_public_path__ + "img/logo-dtours.20cfa1ec.jpg";